/* Built In Imports */
import { useEffect, useState } from 'react';

/* External Imports */
import { Box, Flex, Image } from '@chakra-ui/react';
import { format } from 'date-fns';
import { render } from 'datocms-structured-text-to-html-string';
import { useRouter } from 'next/router';
import { useMediaQuery } from 'react-responsive';

/* Internal Imports */
/* Components */
import SimpleButton from '@components/Buttons/SimpleButton';
import StructuredTextContent from '@components/UI/StructuredTextContent';

/**
 * Returns the Top Banner Event .
 *
 * @param sectionContent.sectionContent
 * @param {object} sectionContent - Content from API
 * @param {string} region - Region of page
 * @param {string} language - Lang of page
 * @returns {ReactElement} TopBannerEvent component
 */

const TopBannerEventHyttV2 = ({
  sectionContent,
  region,
  language,
  pageName,
  FYDdate,
  pageConfig,
  csrData,
  secImage,
}) => {
  const pName = pageConfig?.pageName;
  const [disableButton, setDisableButton] = useState(false);
  const [newButton, setNewButton] = useState(null);
  const [formattedDate, setFormattedDate] = useState('');
  const isMobile = useMediaQuery({ maxWidth: 960 });
  const styles = {
    default: 'polygon(0 0, 100% 0, 100% 100%, 0 85%)',
    'without-bottom-angle': '',
    '': 'polygon(0 0, 100% 0, 100% 100%, 0 85%)',
  };
  const router = useRouter();

  useEffect(() => {
    // Check if programData is defined and has the active 'eventPgmId' property
    if (csrData && csrData[0]?.eventPgmId != null) {
      const date = new Date(csrData[0]?.date + 'T10:16:29.060Z');
      const newFormattedDate = format(date, 'MMM do yyyy');
      setFormattedDate(newFormattedDate);
      const disableButton = csrData[0]?.eventPgmId === undefined;
      setDisableButton(disableButton);
    }

    if (pName === 'freeyogaday' && !csrData?.length > 0) {
      setDisableButton(true);
    }
  }, [csrData]);

  useEffect(() => {
    // console.log('useEffect', sectionContent, router.asPath.indexOf('21-day-challenge-idy'), router.query.referrer_id, region)
    if (
      region !== 'in' &&
      router.asPath.indexOf('21-day-challenge-idy') > -1 &&
      router.query.referrer_id
    ) {
      sectionContent.button[0].linkUrl = '#challenge-form';
      setNewButton(sectionContent.button);
      // console.log('sectionContent11', sectionContent);
    }
    // console.log('useEffect2', sectionContent)
  }, [router.query, router.asPath]);

  const clickH = values => {
    // console.log('clickH', router.asPath);
    if (router.asPath.indexOf('21-day-challenge-idy') > -1) {
      window.dataLayer.push({
        event:
          region === 'in' ? 'IDY_Accept_Challenge' : 'IDY_Download_the_app',
        IDY_LP_Location: 'Top_level_CTA',
      });
    }
  };

  return (
    <Box
      display={'grid'}
      // mb={'70px'}
      pos={'relative'}
      h={{ base: '100%', md: 'auto' }}
      // maxH={620}
      // minH={{ base: 550 }}
      bgColor={{
        base: pageName === 'IDYPage' ? '#fffcf5' : '#f8f5f0',
        lg: 'transparent',
      }}
    >
      <Box height={'auto'} w={'100%'}>
        <Box
          alignItems={'center'}
          display={'flex'}
          h={{
            base: '110.9375vw',
            sm: pName === 'hytt' ? '760px' : '500px',
          }}
          minH={{
            base: '140.9375vw',
            sm: '500px',
          }}
          backgroundRepeat="no-repeat"
          bgColor={{
            base: pageName === 'IDYPage' ? '#fffcf5' : '#f8f5f0',
            sm: 'transparent',
          }}
          backgroundSize={{ base: 'cover', sm: 'cover' }}
          backgroundPosition={{
            base: 'center 0',
            sm: 'center 0',
            md: pageName === 'IDYPage' ? '100%' : '',
            lg: 'top center',
            xl: 'center',
          }}
          backgroundImage={{
            md: sectionContent?.desktopImage?.url,
            base:
              sectionContent?.mobileImage?.url ||
              sectionContent?.desktopImage?.url,
            // ? show right of image in desktopImage when there is no mobileImage
          }}
          mb={{ base: '0', xl: '0' }}
          clipPath={styles[sectionContent.style]}
        >
          {!isMobile && (
            <Flex
              flexDirection="column"
              verticalAlign={'center'}
              p={{
                base: '7px',
                md: pName === 'hytt' ? '0 0 0 18%' : '0 0 0 5%',
              }}
              w={{ base: '100%', sm: '100%', md: '50%' }}
              maxW={{
                base: 'auto',
                md:
                  pageName === 'ishanga7'
                    ? '430px'
                    : pName === 'hytt'
                    ? '670px'
                    : '40%',
              }}
              fontSize={{
                sm: '44px',
                base: '30px',
              }}
              color={'#FFFFFF'}
              fontFamily="FedraSansStd-A-medium"
              display={{
                base: 'none',
                sm: 'none',
                lg: 'flex',
              }}
              //id="banner-text"
            >
              {/* {pageName === 'IDYPage' && (
                <Box fontSize={{ md: '18px' }} fontWeight="400">
                  UNESCO PRESENTS
                </Box>
              )} */}
              {secImage?._modelApiKey === 'single_image' && (
                <Image
                  src={secImage?.image?.url}
                  w={'260px'}
                  h={'50px'}
                  marginBottom={'37px'}
                />
              )}
              {sectionContent?.title === 'MahaShivRatri' ? (
                <Box as="h1" lineHeight="45px" color="#c7bfad">
                  {sectionContent?.title}
                </Box>
              ) : pName == 'hytt' ? (
                <Box
                  as="h1"
                  color={'white'}
                  // fontFamily={"Fedra Serif A Std"}
                  fontWeight={'500'}
                  fontSize={{ base: '32px', md: '42px' }}
                  lineHeight={'50px'}
                  w={'382px'}
                >
                  {sectionContent?.title}
                </Box>
              ) : (
                <Box
                  as="h1"
                  lineHeight={pageName === 'ishanga7' ? '116%' : '1.25em'}
                  fontWeight={'350'}
                  fontSize={{ base: '32px', md: '44px' }}
                >
                  {sectionContent?.title}
                </Box>
              )}
              {csrData && (
                <Box
                  fontSize={{
                    base: '16px',
                    md: language === 'en' ? '30px' : '20px',
                  }}
                  fontFamily="FedraSansStd-medium"
                  color="#B95C23"
                  mb={{ base: '8px', md: '15px' }}
                  letterSpacing="1px"
                >
                  {formattedDate}
                </Box>
              )}
              {render(sectionContent.titleSubtext) &&
                render(sectionContent?.titleSubtext) !== '<p></p>' && (
                  <Box
                    fontSize={{
                      base: '16px',
                      md: language === 'en' ? '30px' : '20px',
                    }}
                    fontFamily="FedraSansStd-medium"
                    color="#B95C23"
                    mb={{ base: '8px', md: '15px' }}
                    letterSpacing="1px"
                  >
                    {StructuredTextContent(sectionContent.titleSubtext)}
                  </Box>
                )}
              {render(sectionContent?.description) &&
                render(sectionContent?.description) !== '<p></p>' && (
                  <Box
                    id="event-description"
                    fontSize={{
                      base: '16px',
                      md:
                        language === 'en'
                          ? '18px'
                          : pName === 'hytt'
                          ? '18px'
                          : '12px',
                    }}
                    lineHeight={{ base: '24px', md: '28px' }}
                    fontFamily="FedraSansStd-book"
                    color={pName == 'hytt' ? '#FDE6B7' : '#333333'}
                    w={'382px'}
                  >
                    {StructuredTextContent(sectionContent.description)}
                  </Box>
                )}
              {render(sectionContent?.date) &&
                render(sectionContent?.date) !== '<p></p>' && (
                  <Box
                    fontSize={{
                      base: '16px',
                      md:
                        language === 'en'
                          ? '22px'
                          : pName == 'hytt'
                          ? '24px'
                          : '18px',
                    }}
                    fontFamily="FedraSansPro"
                    fontWeight="bold"
                    lineHeight={'28px'}
                    mt={6}
                    mb={2}
                    color={pName == 'hytt' ? '#FFAE27' : '#B95C23'}
                  >
                    {StructuredTextContent(sectionContent.date)}
                  </Box>
                )}
              {render(sectionContent?.closedMessage) &&
                render(sectionContent?.closedMessage) !== '<p></p>' && (
                  <Box
                    fontSize={{ base: '16px', md: '20px' }}
                    fontFamily="FedraSansStd-book"
                    color={pName == 'hytt' && '#FFFFFF'}
                  >
                    {StructuredTextContent(sectionContent.closedMessage)}
                  </Box>
                )}
              {sectionContent?.button?.length > 0 && (
                <Box marginTop="10px">
                  {/* <NextLink
                  href={refineUrlDomain(
                    sectionContent.button[0]?.linkUrl,
                    region,
                    language
                  )}
                  passHref
                >
                  <Link
                    display="inline-block"
                    mb="20px"
                    fontFamily="FedraSansStd-book"
                    borderRadius="3px"
                    bgColor="#cf4520"
                    color="rgb(250 247 240)"
                    fontSize="18px"
                    padding="15px 35px"
                    textDecoration="none"
                    _hover={{
                      bg: '#000054',
                    }}
                  >
                    {sectionContent.button[0]?.buttonText}
                  </Link>
                </NextLink> */}

                  <SimpleButton
                    style={sectionContent.button[0]}
                    region={region}
                    lang={language}
                    mb="5px"
                    pageName={pageName}
                    pageConfig={pageConfig}
                    disableButton={disableButton}
                    clickHandler={() => {
                      clickH();
                    }}
                    cta="top cta"
                    program_name="Hatha Yoga Teacher Training"
                    mixpanelenabled="true"
                    eventid="hytt_cta_click"
                  />
                </Box>
              )}

              {render(sectionContent?.bottomText) &&
                render(sectionContent?.bottomText) !== '<p></p>' && (
                  <Box
                    id="donate-button"
                    fontSize={{
                      base: '16px',
                      md: language === 'en' ? '16px' : '12px',
                    }}
                    fontFamily="FedraSansStd-book"
                    mb="10px"
                    mt="10px"
                    lineHeight="160%"
                    color={pName == 'hytt' ? '#ffffff' : ''}
                  >
                    {StructuredTextContent(sectionContent.bottomText)}
                  </Box>
                )}

              {sectionContent?.secondaryCta?.length > 0 && (
                <Box marginTop="5px">
                  <SimpleButton
                    style={sectionContent.secondaryCta[0]}
                    region={region}
                    lang={language}
                    mb="5px"
                    minW={pageName === 'ishanga7' ? '256px' : '200px'}
                    textAlign="center"
                    mt="0"
                    pageName={pageName}
                    pageConfig={pageConfig}
                    disableButton={disableButton}
                    cta="top cta"
                    program_name="Hatha Yoga Teacher Training"
                    mixpanelenabled="true"
                    eventid="hytt_cta_click"
                  />
                </Box>
              )}
            </Flex>
          )}
        </Box>

        {isMobile && (
          <Flex
            display={{
              base: 'flex',
              sm: 'flex',
              md: 'flex',
              lg: 'none',
              xl: 'none',
            }}
            flexDirection="column"
            verticalAlign={'center'}
            w={
              pName === 'hytt'
                ? { base: '100%', sm: '100%', md: '100%', lg: '50%' }
                : { base: '100%', sm: '80%', md: '96%', lg: '50%' }
            }
            p={{
              base: pName == 'hytt' ? '30px 26px' : '20px 15px',
              sm: pName == 'hytt' ? '30px 40px' : '20px 15px',
              md: '30px',
            }}
            fontSize={{
              sm: '44px',
              base: '30px',
            }}
            color={'#28231e'}
            fontFamily="FedraSansStd-A-medium"
            // bgColor={{
            //   base: pageName === 'IDYPage' ? '#fffcf5' : '',
            //   lg: 'transparent',
            // }}
            bgColor={{
              base:
                pageName === 'IDYPage'
                  ? '#fffcf5'
                  : pName === 'hytt'
                  ? '#1D1D1D'
                  : '',
              lg: 'transparent',
            }}
            height={pName === 'hytt' && '220px'}
          >
            {secImage?._modelApiKey === 'single_image' && (
              <Image
                src={secImage?.image?.url}
                w={'260px'}
                h={'50px'}
                marginBottom={'37px'}
                marginTop={'-190px'}
              />
            )}
            {/* {pageName === 'IDYPage' && (
              <Box fontSize={{ base: '16px', sm: '16px' }} fontWeight="400">
                UNESCO PRESENTS
              </Box>
            )} */}
            <Box
              as="h1"
              fontSize={{
                base: pName === 'hytt' ? '28px' : '32px',
                md: pageName === 'ishanga7' ? '65.67px' : '44px',
              }}
              lineHeight={{
                base: '40px',
                md: pageName === 'ishanga7' ? '116%' : '1.25em',
              }}
              fontWeight={pName === 'hytt' ? '500' : '350'}
              color={pName == 'hytt' ? 'white' : ''}
            >
              {sectionContent?.title}
            </Box>
            {csrData && (
              <Box
                fontSize={{
                  base: '16px',
                  md: language === 'en' ? '30px' : '20px',
                }}
                fontFamily="FedraSansStd-medium"
                color="#B95C23"
                mb={{ base: '8px', md: '15px' }}
                letterSpacing="1px"
              >
                {formattedDate}
              </Box>
            )}
            {sectionContent.titleSubtext && (
              <Box
                fontSize={{ base: '20px', md: '28px', lg: '30px' }}
                fontFamily="FedraSansStd-medium"
                color="#B95C23"
              >
                {StructuredTextContent(sectionContent.titleSubtext)}
              </Box>
            )}
            {render(sectionContent?.description) &&
              render(sectionContent?.description) !== '<p></p>' && (
                <Box
                  id="event-description"
                  fontSize={{ base: '16px', md: '18px' }}
                  fontFamily="FedraSansStd-book"
                  color={pName == 'hytt' ? '#FDE6B7' : '#333333'}
                >
                  {StructuredTextContent(sectionContent.description)}
                </Box>
              )}
            {render(sectionContent?.date) &&
              render(sectionContent?.date) !== '<p></p>' && (
                <Box
                  fontSize={{
                    base: pName === 'hytt' ? '20px' : '18px',
                    md: '20px',
                  }}
                  fontFamily="FedraSansStd-book"
                  fontWeight="bold"
                  lineHeight={'28px'}
                  mt={6}
                  color={pName == 'hytt' ? '#FFAE27' : '#B95C23'}
                >
                  {StructuredTextContent(sectionContent.date)}
                </Box>
              )}
            {render(sectionContent?.closedMessage) &&
              render(sectionContent?.closedMessage) !== '<p></p>' && (
                <Box
                  fontSize={{ base: '16px', md: '20px' }}
                  fontFamily="FedraSansStd-book"
                  className={
                    pName === 'hytt' ? 'hytt-closemessage' : 'closeMessage'
                  }
                >
                  {StructuredTextContent(sectionContent.closedMessage)}
                </Box>
              )}
            {sectionContent?.button?.length > 0 && (
              <Box marginTop={pName === 'hytt' ? '0px' : '18px'} h="auto">
                {/* <NextLink
                href={refineUrlDomain(
                  sectionContent.button[0]?.linkUrl,
                  region,
                  language
                )}
                passHref
              >
                <Link
                  display="inline-block"
                  mb="20px"
                  fontFamily="FedraSansStd-book"
                  borderRadius="3px"
                  bgColor="#D04723"
                  lineHeight="22.5px"
                  color="rgb(250 247 240)"
                  fontSize="18px"
                  padding="15px 35px"
                  textDecoration="none"
                  _hover={{
                    bg: '#000054',
                  }}
                >
                  {sectionContent.button[0]?.buttonText}
                </Link>
              </NextLink> */}
                {/* <SimpleButtonHyttV2
                  style={sectionContent.button[0]}
                  region={region}
                  lang={language}
                  mb={pageName === 'ishanga7' ? '10px' : '0'}
                  mt={pName === "hytt" ? '0px' : '12px'}
                  pageName={pageName}
                  pageConfig={pageConfig}
                  disableButton={disableButton}
                  clickHandler={() => {
                    clickH();
                  }}
                /> */}
              </Box>
            )}
            {render(sectionContent?.bottomText) &&
              render(sectionContent?.bottomText) !== '<p></p>' && (
                <Box
                  id="donate-button"
                  fontSize={{ base: '16px', md: '20px' }}
                  fontFamily="FedraSansStd-book"
                  mb={sectionContent?.secondaryCta?.length ? '10px' : '0'}
                  mt={'10px'}
                  color={pName == 'hytt' ? '#ffffff' : ''}
                >
                  {StructuredTextContent(sectionContent.bottomText)}
                </Box>
              )}
            {sectionContent?.secondaryCta?.length > 0 && (
              <Box mt="0">
                {/* <SimpleButton
                  style={sectionContent.secondaryCta[0]}
                  region={region}
                  lang={language}
                  mb="15px"
                  minW={pageName === 'ishanga7' ? '256px' : '200px'}
                  textAlign="center"
                  pageName={pageName}
                  pageConfig={pageConfig}
                  disableButton={disableButton}
                /> */}
              </Box>
            )}
            {/* {currentUrl && (
              <Box fontSize="16px" m="20px 0">
                <AddToCalendarButton
                  name="Guru Poornima Test Event"
                  description="Guru Poornima Test Event Description"
                  startDate="2023-05-22"
                  options={['Apple', 'Google', 'Yahoo', 'Microsoft365']}
                  hideBackground={true}
                  trigger="click"
                  hideCheckmark={true}
                ></AddToCalendarButton>
              </Box>
            )} */}
          </Flex>
        )}
      </Box>
      <style global jsx>
        {`
          #event-description h2 {
            font-size: 27px;
            color: #28231e;
            font-family: 'FedraSansStd-medium';
            padding: 15px 0 0 0;
          }
          @media (max-width: 1300px) {          
            #banner-text{
              padding: 0 0 0 5% !important; 
            }
        }
          #donate-button a {
            color:#cf4520;
            text-decoration:underline;
          }
          #donate-button a:hover {
            text-decoration:none;
          }
          .closeMessage {
            color: black;
            margin-top: 5px;
            font-size: 16px;
          }
          .closeMessage a {
            color: #cf4824;
          }
          .hytt-closemessage {
            color:#FFFFFF;
            margin-top: 5px;
            font-size: 16px;
          }

          @media (max-width: 767px) {
            #event-description h2 {
              font-size: 20px;
          }        
        `}
      </style>
    </Box>
  );
};

export default TopBannerEventHyttV2;
